import { Dispatch } from 'redux';
import { GetState, Building } from 'models';
import { BuildingsActionTypes } from './action-types';
import services from 'services';

export const fetchBuildings = () => {
  return (dispatch: Dispatch, getState: GetState) => {
    const { current_cooperative } = getState().settings;

    dispatch({ type: BuildingsActionTypes.REQUEST_BUILDINGS_START });

    services
      .get(`/api/cooperatives/${current_cooperative}/buildings`)
      .then(({ data: { Data } }) => {
        const fetchedBuildings: Building[] = Data;

        dispatch({
          type: BuildingsActionTypes.REQUEST_BUILDINGS_SUCCESS,
          payload: fetchedBuildings,
        });
      })
      .catch(() =>
        dispatch({ type: BuildingsActionTypes.REQUEST_BUILDINGS_FAILED })
      );
  };
};
